<template>
    <div id="explanation-wrapper">
        <transition name="fade">
            <div v-show="show">
                <explanation></explanation>

                <div class = "do-not-show">
                    <span>{{'do_not_show_again_intro' | lang}} </span> <input v-model="dontShowIntro" type="checkbox">
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

import { mapMutations, mapState } from 'vuex';
import $ from "jquery";
import "bootstrap";

export default {
    data() {
        return {
            dontShowIntro: false,
            show: false
        };
    },
    methods: {
        ...mapMutations(['toggleExplanation']),
        hideExplanation() {
            if(this.explanationVisible) {
                if(this.explanationCallback) {
                    this.explanationCallback();
                }
                
                this.toggleExplanation({callback:false, dontShowIntro:this.dontShowIntro});
            }
        },
        showEvent() {
            this.show = true;

        }
    },
    components: {
        Explanation: resolve => {
            resolve({
                template: Config.explanation_template,
                data() {
                    return {
                        gameName: Config.game_name.toLowerCase(),
                        gameNameUpper: Config.game_name,
                        percent: Config.percent,
                        version: Config.version,
                    };
                },
                mounted() {
                    $('.carousel').carousel({
                        interval: 4000
                    });

                    this.$parent.showEvent();
                }
            });
        },
    },
    computed: {
        ...mapState([
            'explanationCallback',
            'explanationVisible'
        ]),
    },
}
</script>

<style>
    #explanation-wrapper .do-not-show {
        position:absolute;
        color:white;
        font-size: 16px;
        right: 10px;
        bottom: 10px;
    }

    #explanation-wrapper .fade-enter-active {
        transition: opacity 0.6s;
    }

    #explanation-wrapper .fade-enter, #explanation-wrapper .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    @media (orientation:portrait) { 
        #explanation-wrapper .do-not-show {
            width: 100%;
            text-align: center;
        }
    }

</style>